import { render, staticRenderFns } from "./SocorroMasPage.vue?vue&type=template&id=7121784a"
import script from "./SocorroMasPage.js?vue&type=script&lang=js&external"
export * from "./SocorroMasPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports